// 🔧 homepage_defaults.js
// ✅ Purpose: Creates default homepage content for Demo Engine events
// ✅ Features:
// - Provides realistic homepage content for demo events
// - Industry-specific messaging
// - Future-ready for AI-generated content
// - Fully block-commented for clarity and future devs

export const buildHomepageContent = ({
  eventName,
  industryTemplate,
} = {}) => {
  const industryLabel =
    industryTemplate?.label || "Car Show";

  return {
    headline:
      `Welcome to the ${eventName}`,

    subHeadline:
      `Experience how Let's Go Vote powers a modern ${industryLabel.toLowerCase()} event.`,

    description:
      "This fully-functional demo event allows you to explore registration, entries, voting, leaderboards, winners, sponsors, volunteers, maps, schedules, and more exactly as your attendees would.",

    participationTips: [
      "Browse the event entries.",
      "Cast demo votes.",
      "Visit the leaderboard.",
      "Explore sponsor pages.",
      "Review event schedules.",
    ],

    callToAction:
      "Everything you see here was automatically generated by the LGV Demo Engine.",

    demoGenerated: true,
  };
};